//#region IMPORTS
import { PlusCircleIcon } from "@heroicons/react/20/solid";
import { ReactNode } from "react";
import classNames from "../../../helpers/classNames";
//#endregion

//#region INTERFACE
interface Props {
  hidePlusIcon?: boolean;
  clickHandler?: () => void;
  children?: ReactNode;
  disabled?: boolean;
  value?: string;
}
//#endregion

export default function ActionButton({
  hidePlusIcon = false,
  clickHandler,
  children,
  disabled = false,
  value,
}: Props) {
  //#region RENDER
  return (
    <button
      disabled={disabled}
      className={classNames(
        "inline-flex items-center gap-x-2 rounded-md bg-emerald-600 px-2 py-1 text-1xl font-semibold text-white shadow-sm hover:bg-emerald-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600",
        disabled && "cursor-not-allowed opacity-50"
      )}
      onClick={clickHandler}
      type="button"
    >
      {!hidePlusIcon && !children && (
        <PlusCircleIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
      )}
      {children && children}
      {value}
    </button>
  );
  //#endregion
}
